module.exports = __webpack_public_path__ + "img/bg_left.c49a9b8d.png";